// src/Component/AdminProtectedRoute.js
import { Navigate } from "react-router-dom";

const AdminProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("userToken") !== null;
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  // Not logged in → go to admin login
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  // Logged in but not admin → send to supplier dashboard
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // All checks passed → render admin content
  return children;
};

export default AdminProtectedRoute;